<template>
  <v-layout>
    <v-row justify="center">
        <v-col cols="9" xs="8" sm="8" md="6" lg="6" xl="6">
        <v-list dense>
            <v-subheader>
                <v-text-field light v-model="search">
                    <template v-slot:label>
                        <strong>Pretraga...</strong><v-icon>mdi-file-find</v-icon>
                    </template>
                </v-text-field>
            </v-subheader>
            <v-list-item-group v-model="selectedItem" color="primary">
                <v-list-item v-for="(item, i) in list" :key="i" color="accent" @click="createPdf(item, i)">
                    <v-list-item-avatar color="accent" size="48">
                        <span class="white--text headline">{{ getInitials(item.name)}}</span>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title v-text="item.name"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>
        </v-col>
    </v-row>
  </v-layout>
</template>

<script>
// import axios from 'axios'
import { PDFDocument, rgb } from 'pdf-lib'
import fontkit from '@pdf-lib/fontkit'
export default {
    name: 'Certificate',
    data () {
        return {
            selectedItem: null,
            search: '',
            cert: {
                name: '',
                template: {
                    pdf: ''
                },
                subscribers: []
            }
        }
    },
    computed: {
        list () {
            if (this.cert.subscribers.length === 0) return []
            if (this.search.trim().length === 0) return this.cert.subscribers
            return this.cert.subscribers.filter(u => u.name.toLowerCase().includes(this.search.toLowerCase()))
        }
    },
    methods: {
        getInitials (nameString) {
            const fullName = nameString.split(' ');
            const initials = fullName.shift().charAt(0) + fullName.pop().charAt(0);
            console.log(initials)
            return initials.toUpperCase()
        },
        async createPdf(item, i) {
            const fonturl = '/fonts/GreatVibes-Regular.ttf'
            // const fonturl2 = '/fonts/Anton-Regular.ttf'
            const fontBytes1 = await fetch(fonturl).then(res => res.arrayBuffer())
            // const fontBytes2 = await fetch(fonturl2).then(res => res.arrayBuffer())

            const pdfDoc = await PDFDocument.create()
            pdfDoc.registerFontkit(fontkit)
            const GreatVibes = await pdfDoc.embedFont(fontBytes1)
            // const Anton = await pdfDoc.embedFont(fontBytes2)
            const templateUrl = this.cert.template.pdf // '/CReticate_AGMA_Unity1_template.pdf'
            const templateBytes = await fetch(templateUrl).then(res => res.arrayBuffer())
            const templatePdfDoc = await PDFDocument.load(templateBytes)
            const [templatePage] = await pdfDoc.copyPages(templatePdfDoc, [0])
            const page = await pdfDoc.addPage(templatePage)
            i = parseInt(i)
            let id = i
            console.log(id)
            // if (i < 10) id = '00' + i
            // if (i > 10 && i < 100) id = '0' + i
            // const certNum = 'UC' + id + '/2021'
            // const certNumSize = 13
            const userName = item.name
            const userNameSize = 170
            const userTextWidth = GreatVibes.widthOfTextAtSize(userName, userNameSize)
            console.log(userTextWidth, page.getWidth())
            /* page.drawText(certNum, {
                x: 730,
                y: 534,
                size: certNumSize,
                font: Anton,
                color: rgb(0, 0, 0),
            }) */

            page.drawText(userName, {
                x: Math.floor((page.getWidth() / 2) - (userTextWidth/2)),
                y: 1700,
                size: userNameSize,
                font: GreatVibes,
                color: rgb(0, 0, 0),
            })
            const pdfBytes = await pdfDoc.save()
            // console.log('pdf complete', pdfBytes)
            await this.savePdf(item.name + '.pdf', pdfBytes)
        },
        async savePdf(reportName, byte) {
            var blob = new Blob([byte], {type: "application/pdf"});
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.target = '_system'
            link.location = 'yes'
            var fileName = reportName;
            link.download = fileName;
            link.click();
        }
    },
    async created () {
        console.log('created', this.$route.params)
        // await this.createPdf()
        const data = await fetch('/certificates.json').then(resp => resp.json())
        const cert = data.certs.find(c => c.name.toLowerCase().trim() === this.$route.params.cert.toLowerCase().trim())
        console.log(cert)
        this.cert = cert
    }
}
</script>